import React from 'react'
import SchedulesHomeNavigation from './SchedulesHomeNavigation'
import SearchByLeagueOrVenue from '../UIElements/SearchByLeagueOrVenue'
import FullSchedule from '../../schedule/FullSchedule'
import SelectLeagueSchedule from '../UIElements/SelectLeagueSchedule'

const SchedulesHome = () => {
	return (
		<div style={{ overflowX: 'hidden' }}>
			<SchedulesHomeNavigation />
			<SelectLeagueSchedule />
			<SearchByLeagueOrVenue />
			<FullSchedule />
		</div>
	)
}

export default SchedulesHome
